import type { EditorialSlice } from './editorialContent';
import { editorialSlice } from './editorialContent';
import type { PlayersSlice } from './player';
import { playerSlice } from './player';

import type { StateCreator } from '@shared-types/zustand.types';

export type TopScorerState = EditorialSlice & PlayersSlice;

export const reducer: StateCreator<TopScorerState> = (...args) => ({
  ...editorialSlice(...args),
  ...playerSlice(...args),
});
